<template>
    <div class="boodschapp">
      <main-header/>
      <product-counter/>
      <router-view/>
      <v-btn
        ref="fab"
        absolute
        dark
        fab
        bottom
        right
        color="primary"
        style="bottom: 28px; color: rgba(0,0,0,.87); position: fixed;"
        @click="fab"
        v-if="icon.length > 0">
        <transition name="fade" mode="out-in">
          <v-icon :key="icon">{{ icon }}</v-icon>
        </transition>
      </v-btn>
    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { MainHeader, ProductCounter } from '@/components/organisms'
  import { EventBus } from '@/main'
  import { TimelineMax, Back } from 'gsap/TweenMax'

  export default {
    name: 'boodschapp',
    components: {
      MainHeader,
      ProductCounter
    },
    computed: {
      icon () {
        if (this.$route.name === 'list' && this.$store.getters.getShoppingState) {
          // return 'stop'
          return 'done'
        } else {
          switch (this.$route.name) {
            case 'lists': return 'add'
            case 'list': return 'add'
            case 'addList': return 'done'
            case 'categories': return 'add'
            case 'category': return 'add'
            case 'addCategory': return 'done'
            case 'addProduct': return 'done'
          }
        }
      }
    },
    watch: {
      icon () {
        this.animateFab()
      }
    },
    methods: {
      ...mapActions({
        initCatalog: 'initCatalog'
      }),
      initApp () {
        this.initCatalog()
      },
      fab () {
        this.$store.commit('SET_NAV_DIRECTION', 'forward')

        if (this.$route.name === 'list' && this.$store.getters.getShoppingState) {
          this.$store.commit('TOGGLE_SHOPPING_MODE')
          this.$store.dispatch('setCollectedItemsToSuggestion')
          return
        } else {
          switch (this.$route.name) {
            case 'lists': return this.$router.push({name: 'addList'})
            case 'list': return this.$router.push({name: 'categories'})
            case 'addList': return EventBus.$emit('done-adding-list')
            case 'categories': return this.$router.push({name: 'addCategory'})
            case 'category': return this.$router.push({name: 'addProduct'})
            case 'addCategory': return EventBus.$emit('done-adding-category')
            case 'addProduct': return EventBus.$emit('done-adding-product')
          }
        }
      },
      animateFab () {
        const el = this.$refs.fab.$el
        new TimelineMax({ delay: 0.4 })
          .to(el, 0.4, { rotation: 360, scale: 0, ease: Back.easeIn.config(1.2) })
          .to(el, 0.4, { rotation: 0, scale: 1, ease: Back.easeOut.config(1.2) })
      }
    },
    created () {
      if (this.$store.getters.getCurrentListID === null) {
        this.$router.push({name: 'lists'})
      }

      if (localStorage.getItem('vuex') === null) this.initApp()
      // console.log(this.$store.)
      this.$store.commit('TOGGLE_SHOPPING_MODE', false)
    }
  }
</script>

<style lang="scss" scoped>
  .boodschapp {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-top: 56px;
    padding-bottom: 100px;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 0.2s ease-in-out 0.2s;
  }
  .fade-leave-active {
    transition: opacity 0.2s ease-in-out 0.4s;
  }
</style>



// WEBPACK FOOTER //
// Boodschapp.vue?1f09c501